import React from 'react'
import { CreateStarChartOrgHeaderBanner, CreateStarChartOrgHeaderBox, CreateStarChartOrgHeaderIcon, CreateStarChartOrgHeaderText, CreateStarChartOrgHeaderWrapper, StarChartOrgLabel, StarChartOrgSaveButton } from './CreateStarChartOrgHeaderPresentation.style'
import { images } from '../../../../constants'
import { Column, Input } from '../../../../assets/style/General.style'
import SelectField from '../../../../components/design/selectFiled/selectField'
import { StarChartsOrgActionCol, StarChartsOrgTitle } from '../starChartOrg.action.presentation/starChartOrg.action.presentation.styles'
import { CreateStarChartOrgHeaderPresentationProps } from '../../types/types'

const CreateStarChartOrgHeaderPresentation: React.FC<CreateStarChartOrgHeaderPresentationProps> = ({    
  starChartName, 
  setStarChartName
}) => {

  return (
    <CreateStarChartOrgHeaderWrapper>

        <CreateStarChartOrgHeaderBanner>

            <CreateStarChartOrgHeaderText>Star Chart</CreateStarChartOrgHeaderText>

            <CreateStarChartOrgHeaderIcon src={images.StarchartIcon} alt="gradegy" />

        </CreateStarChartOrgHeaderBanner>

        <CreateStarChartOrgHeaderBox>

            <Column Direction="column" alignment={''} width={'fit-content'} minWidth={''} style={{  flex: "inherit"}}>

                <StarChartOrgLabel htmlFor="starChartName">Name</StarChartOrgLabel>

                <Input
                    type="text"
                    id="starChartName"
                    name="starChartName"
                    value={starChartName}
                    placeholder='Star Chart Name'
                    onChange={(e) => { setStarChartName!(e.target.value) } } 
                    Width={''} Height={''} FontFamily={''} Size={''} Weight={''}  SpacingLR={'10px'}   
                    style={{textAlign:"left"}}             
                    />

            </Column>
            <StarChartsOrgActionCol style={{marginLeft:10 ,width:"15%"}}>
              <StarChartsOrgTitle>Status</StarChartsOrgTitle>

              <SelectField defaultValue={""} onChange={() => {}}>
                <option value="Standard">All</option>
                <option value="Academic">Active</option>
                <option value="Academic">Deactive</option>
              </SelectField>
            </StarChartsOrgActionCol>

            <StarChartOrgSaveButton
                spaceLeft="25px"
                onClick={()=>{}}
                style={{ borderRadius: 5, fontSize: 13 }}>
                Save
            </StarChartOrgSaveButton>

        </CreateStarChartOrgHeaderBox>

    </CreateStarChartOrgHeaderWrapper>
  )
}

export default CreateStarChartOrgHeaderPresentation

